/** @format */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import {
  ActionIcon,
  Badge,
  Button,
  Pagination,
  Select,
  Skeleton,
  Table,
  Text,
  TextInput,
  Anchor,
  Modal,
} from "@mantine/core";
import { BeatLoader } from "react-spinners";
import { DatePicker } from "@mantine/dates";
import {
  Eye,
  History,
  Search,
  Plus,
  SortAscending,
  SortDescending,
} from "tabler-icons-react";
import { formatISO } from "date-fns";
import { useDebouncedValue } from "@mantine/hooks";
import {
  deleteAgreementBulk,
  getAgreementsDocsLockerCsvDownload,
  getAgreementsInReviewCsvDownload,
} from "../../utilities/apis/agreements";
import {
  getValueForInput,
  loadingStates,
  csvDownload,
  formatDate,
  formatIndianNumber,
  getObStatusText,
} from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  getDocLockerList,
  getAgreementTypesApi,
  getAgreementsCsvDownload,
} from "../../utilities/apis/agreements";
import UserAvatarView from "../../components/UserAvatarView";
import DashboardNotifications from "../DashboardNotifications";
import {
  agreementStatusColors,
  getStatusColor,
  getStatusText,
} from "../../utilities/enums";
import AgreementAnalytics from "../../components/AgreementAnalytics/AgreementAnalytics";
import colors, { themeColor } from "../../utilities/design";
import AgreementGraph from "./AgreementGraph";
import Styles from "./AgreementsListingPage.module.css";
import { INDIA_STATES_UNIONS } from "./AgreementForm2";
import { selectUserData } from "../../redux/selectors";
import { useSelector } from "react-redux";
import AgreementListModal from "./AgreementListModal";
import AgreementAuditLogModal from "./AgreementAuditLogModal";
import RelatedAgreementModal from "./agreementRelatedModal";
import { getBussinessUnit } from "../../utilities/apis/serviceProvider";
import { getPartyNames } from "../../utilities/apis/parties";
import { IconArrowDownBar, IconArrowUpBar } from "@tabler/icons-react";
import TablePagination from "../../components/Common/TablePagination";
import UniversalTable from "../../components/Common/UniversalTable";

const statusOptions = [
  // {
  //   label: "INITIATED",
  //   value: "CREATED",
  // },
  // {
  //   label: "UNDER REVIEW",
  //   value: "Review",
  // },
  // {
  //   label: "PENDING APPROVAL",
  //   value: "Approval",
  // },
  {
    label: "FINALISED",
    value: "Signature",
  },
  {
    label: "PENDING SIGNATURE",
    value: "SENT",
  },
  {
    label: "PARTIALLY COMPLETED",
    value: "PARTIALLYCOMPLETED",
  },
  {
    label: "CANCELLED",
    value: "CANCELLED",
  },
  {
    label: "DECLINED",
    value: "DECLINED",
  },
  {
    label: "COMPLETED",
    value: "SIGNED",
  },
];
const estampOption = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];

const DocsLocker = () => {
  // let businessunitList = [];
  const [parties, setParties] = useState(["secondparty"]);
  const [businessunitList, setbusinessunitList] = useState([]);

  useEffect(() => {
    const fetchBusinessUnits = async () => {
      try {
        const { data } = await getBussinessUnit();
        if (data) {
          setbusinessunitList(data.businessunitList || []);
        } else {
          console.error("Invalid business unit response format:", response);
        }
      } catch (error) {
        console.error("Error fetching business units:", error);
      }
    };
    const getPartyName = async () => {
      const response = await apiWrapWithErrorWithData(getPartyNames());
      if (response.success) {
        console.log("party de rha h bro: ", response);
        setParties(response.parties);
      }
    };
    getPartyName();
    fetchBusinessUnits();
  }, []);
  // console.log(businessunitList);

  const [open, setOpen] = useState(false);
  const currentUser = useSelector(selectUserData) || {};
  // console.log("ass--", currentUser.loginAs.id);
  const [listing, setListing] = useState({
    list: null,
    agreementsCount: null,
    loaded: false,
    sortBy: "id",
    sortDirection: "desc",
    searchString: "",
    statusType: "",
    estamp: null,
    agreementType: null,
    location: null,
    startDate: null,
    endDate: null,
    partyName: "",
    businessunit: "",
    jobOrder: "",
    obligationStatus: null,
  });
  const [agreementTypeOptions, setAgreementTypeOptions] = useState([]);
  const [pageSize, setPageSize] = useState(10);
  const [uiConfigs, setUiConfigs] = useState({
    loading: loadingStates.NO_ACTIVE_REQUEST,
    page: 1,
  });
  const [debouncedSearchInput] = useDebouncedValue(listing.searchString, 500);
  const [agreementPayload, setAgreementPayload] = useState({});
  const [exportButtonLoading, setExportButtonLoading] = useState(false);

  const handleKeyChange = (val) => {
    // const newSortOption = { key: val, value: sortByOptions.value };
    // setSortByOptions(newSortOption);
    setListing({ ...listing, sortBy: val });
  };
  const toggleOrder = () => {
    setListing({
      ...listing,
      sortDirection: listing.sortDirection === "asc" ? "desc" : "asc",
    });
  };
  const [selectedIds, setSelectedIds] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const handleCheckboxChange = (id, isChecked) => {
    setSelectedIds((prevSelectedIds) => {
      if (isChecked) {
        return [...prevSelectedIds, id];
      } else {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      }
    });
  };

  const deleteHandler = async () => {
    console.log("Deleting agreements with IDs:", selectedIds);
    const agreementIds = selectedIds;
    setDeleteLoading(true);
    const response = await apiWrapWithErrorWithData(
      deleteAgreementBulk({ agreementIds })
    );
    if (response?.success) {
      showNotification({
        color: "green",
        title: "Agreements",
        message: "Agreement deleted successfully.",
      });
      setOpen(false);
      navigate("/app");
    } else {
      showNotification({
        color: "red",
        title: "Agreements",
        message: "Unable to delete agreement",
      });
    }
    setDeleteLoading(false);
  };

  const [transformedData, settransformedData] = useState([]);

  useEffect(() => {
    if (businessunitList.length > 0) {
      settransformedData(
        businessunitList.map((unit) => ({
          value: unit.id + "",
          label: unit.name,
        }))
      );
    }
  }, [businessunitList]);

  const fetchAgreementsList = async ({ page }) => {
    let filterOptions = {};
    if (listing.startDate && listing.endDate) {
      filterOptions["createdAt"] = {
        gte: formatISO(listing.startDate),
        lte: formatISO(listing.endDate),
      };
    } else if (listing.startDate || listing.endDate) {
      showNotification({
        title: "Agreement notification",
        message: "please select start and end date",
        color: "red",
      });
      return;
    }
    setUiConfigs({
      ...uiConfigs,
      loading: loadingStates.LOADING,
    });
    const payload = {
      page: page ? page : uiConfigs.page,
      sortByOptions: {
        [listing.sortBy]: listing.sortDirection,
      },
      pageSize,
    };
    if (
      listing.agreementType &&
      listing.statusType &&
      listing.estamp &&
      listing.businessunit &&
      listing.obligationStatus
    ) {
      filterOptions = {
        ...filterOptions,
        typeOfAgreement: {
          equals: listing.agreementType,
        },
        status: {
          equals: listing.statusType,
        },
        agreementType: {
          equals: listing.estamp === "Yes" ? "eStamp" : "normal",
        },
        mapBusinessunit: {
          equals: listing.businessunit,
        },
        obligationStatus: {
          equals: listing.obligationStatus,
        },
      };
    } else if (
      listing.agreementType ||
      listing.statusType ||
      listing.estamp ||
      listing.businessunit ||
      listing.obligationStatus
    ) {
      if (listing.agreementType) {
        filterOptions["typeOfAgreement"] = {
          equals: listing.agreementType,
        };
      }
      if (listing.statusType) {
        filterOptions["status"] = {
          equals: listing.statusType,
        };
      }
      if (listing.estamp) {
        filterOptions["agreementType"] = {
          equals: listing.estamp === "Yes" ? "eStamp" : "normal",
        };
      }
      if (listing.businessunit) {
        filterOptions["mapBusinessunit"] = {
          equals: listing.businessunit,
        };
      }
      if (listing.obligationStatus) {
        filterOptions["obligationStatus"] = {
          equals: listing.obligationStatus,
        };
      }
    }
    if (listing.location) {
      filterOptions["location"] = listing.location;
    }
    if (listing.obligationStatus) {
      filterOptions["obligationStatus"] = {
        equals: listing.obligationStatus,
      };
    }
    if (listing.partyName.length > 0) {
      filterOptions["OR"] = [
        { secondParty: { path: "$.name", string_contains: listing.partyName } },
        {
          secondParty: {
            path: "$.indi_name",
            string_contains: listing.partyName,
          },
        },
        {
          secondParty: {
            path: "$.brandName",
            string_contains: listing.partyName,
          },
        },
      ];
    }
    if (listing.jobOrder.length > 0) {
      filterOptions["jobOrder"] = { contains: listing.jobOrder };
    }

    payload["filterOptions"] = filterOptions;

    setAgreementPayload(payload);
    const response = await apiWrapWithErrorWithData(
      getDocLockerList({ ...payload })
    );
    if (response?.success && response?.agreements) {
      setListing({
        ...listing,
        list: response?.agreements,
        agreementsCount: response.agreementsCount,
        loaded: true,
      });
    }
    setUiConfigs({
      ...uiConfigs,
      loading: loadingStates.NO_ACTIVE_REQUEST,
    });
  };
  const data = listing?.list;

  useEffect(() => {
    getAgreementTypes();
  }, []);

  useEffect(() => {
    if (listing.agreementType || listing.statusType || listing.estamp) {
      fetchAgreementsList({ page: 1 });
      setUiConfigs((prevState) => ({
        ...prevState,
        page: 1,
      }));
    } else if (listing.estamp) {
      fetchAgreementsList({ page: 1 });
      setUiConfigs((prevState) => ({
        ...prevState,
        page: 1,
      }));
    } else if (listing.startDate && listing.endDate) {
      fetchAgreementsList({ page: 1 });
      setUiConfigs((prevState) => ({
        ...prevState,
        page: 1,
      }));
    } else {
      if (listing.startDate === null && listing.endDate === null) {
        fetchAgreementsList({});
      }
    }
  }, [listing.sortBy, listing.sortDirection]);

  useEffect(() => {
    fetchAgreementsList({});
  }, [uiConfigs.page, pageSize]);

const onViewClick = (agreementId) => {
    const url = `/app/agreements_manager/agreements/details/${agreementId}`;
    window.open(url, '_blank'); // '_blank' specifically tells the browser to open in a new tab/window
};

  const getAgreementTypes = async () => {
    const resp = await apiWrapWithErrorWithData(getAgreementTypesApi());
    if (resp?.success && resp?.typesOfAgreement) {
      const uniqueValues = Array.from(new Set([...resp.typesOfAgreement]));
      const temp = uniqueValues.map((item) => ({ label: item, value: item }));
      setAgreementTypeOptions([...agreementTypeOptions, ...temp]);
    }
  };
  const handleCsvDownload = async () => {
    try {
      setExportButtonLoading(true);
      const response = await apiWrapWithErrorWithData(
        getAgreementsDocsLockerCsvDownload({ ...agreementPayload })
      );
      if (response.success) {
        if (response?.agreements.length > 0) {
          const columnHeaders = Object.keys(response.agreements[0]);
          csvDownload({
            data: response.agreements,
            headers: columnHeaders,
            name: "agreements in docs locker",
          });
        } else {
          showNotification({
            title: "Agreement csv download",
            message: "No agreement available",
            color: "red",
          });
        }
      }
      setExportButtonLoading(false);
    } catch (error) {
      setExportButtonLoading(false);
      showNotification({
        title: "Agreement csv download",
        message: "Could not load agreement csv",
        color: "red",
      });
    }
  };

  const clearHandler = async () => {
    try {
      setUiConfigs({
        ...uiConfigs,
        page: 1,
        loading: loadingStates.LOADING,
      });

      const payload = {
        page: 1,
        sortByOptions: {
          ["createdAt"]: listing.sortDirection,
        },
        filterOptions: {},
        pageSize,
      };

      setAgreementPayload(payload);
      const response = await apiWrapWithErrorWithData(
        getDocLockerList({ ...payload })
      );

      if (response?.success && response?.agreements) {
        setListing({
          ...listing,
          searchString: "",
          agreementType: "",
          statusType: null,
          estamp: "",
          location: null,
          startDate: null,
          endDate: null,
          list: response?.agreements,
          agreementsCount: response.agreementsCount,
          loaded: true,
          estamp: null,
          partyName: "",
          businessunit: "",
          jobOrder: "",
          obligationStatus: null,
        });
      }

      setUiConfigs({
        ...uiConfigs,
        loading: loadingStates.NO_ACTIVE_REQUEST,
      });
    } catch (error) {
      console.log("Agreement list fetching error: ", error);
    }
  };
  const [showModal, setShowModal] = useState(false);
  const [agreementId, setAgreementId] = useState(null);

  const handleSearchClick = (id) => {
    // Set the showModal state to true when the button is clicked
    setShowModal(true);
    // Pass the row id to the AgreementAuditLogModal component
    setAgreementId(id);
  };

  console.log(data);

  const handleCloseModal = () => {
    // Set the showModal state to false when the modal is closed
    setShowModal(false);
  };
  const [showModalRelated, setShowModalRelated] = useState(false);
  const [relatedAgreementId, setRelatedAgreementId] = useState(null);
  const handlePlusClick = (id) => {
    console.log("id: ", id);
    setShowModalRelated(true);
    setRelatedAgreementId(id);
  };
  const handleCloseRelatedAgreementModal = () => {
    setShowModalRelated(false);
  };

   const formatDate = (dateString) => {
     if (!dateString) return "--";
     const date = new Date(dateString);
     // Returns "30/04/2026"
     return date.toLocaleDateString("en-GB");
   };

   const subTextStyle = {
     fontSize: "10px",
     fontWeight: 400,
     opacity: 0.7,
     lineHeight: 1.2,
   };

   const tableHeaders = [
     {
       // CIN / Job Order
       label: (
         <div>
           <div>CIN</div>
           <div style={subTextStyle}>JOB ORDER</div>
         </div>
       ),
       render: (row) => (
         <div className="flex flex-col">
           <Text size="xs" weight={600} color="#2089ae">{`#${row.id}`}</Text>
           <Text size="10px" color="dimmed">
             {row.jobOrder || "NO JO"}
           </Text>
         </div>
       ),
     },
     {
       // Category / BU
       label: (
         <div>
           <div>Category</div>
           <div style={subTextStyle}>BU</div>
         </div>
       ),
       render: (row) => (
         <div className="flex flex-col">
           <Text size="xs" weight={500}>
             {row.agreementData?.json?.typeOfAgreement || "--"}
           </Text>
           <Text size="10px" color="dimmed">
             {row.agreementData?.json?.location || "--"}
           </Text>
         </div>
       ),
     },
     {
       label: "ACV (INR)",
       render: (row) => (
         <Text size="xs" weight={700}>
           {formatIndianNumber(row.agreementValue)}
         </Text>
       ),
     },
     {
       // Brand Name / Second Party
       label: (
         <div>
           <div>Brand Name</div>
           <div style={subTextStyle}>SECOND PARTY</div>
         </div>
       ),
       render: (row) => (
         <div className="flex flex-col" style={{ maxWidth: "180px" }}>
           <Text size="xs" weight={500} truncate>
             {row.agreementData?.json?.brandName || "N/A"}
           </Text>
           <Text size="10px" color="dimmed" truncate>
             {row.agreementData?.json?.secondParty?.name || "--"}
           </Text>
         </div>
       ),
     },
     {
       label: "Status",
       render: (row) => (
         <Badge
           variant="light"
           size="xs"
           color={getStatusColor(row.status)}
           radius="xl"
         >
           {getStatusText(row.status)}
         </Badge>
       ),
     },
     {
       // Contract Start Date (using dateOfContract)
       label: (
         <div>
           <div>Contract Date</div>
           {/* <div style={subTextStyle}>(DD/MM/YYYY)</div> */}
         </div>
       ),
       render: (row) => {
         const dateVal = row.createdAt;
         return <Text size="xs">{dateVal ? formatDate(dateVal) : "--"}</Text>;
       },
     },
     {
       label: "Obligation Status",
       render: (row) => (
         <Badge color={getObStatusText(row.obligationStatus).color}>
           {" "}
           {getObStatusText(row.obligationStatus).text}{" "}
         </Badge>
       ),
     },
     {
       label: "Actions",
       align: "right",
       render: (row) => (
         <div className="flex flex-row justify-end gap-1">
           {row.relationshipWith ? (
             <div className="flex flex-row ">
               <ActionIcon
                 onClick={() => {
                   handlePlusClick(row.id);
                 }}
                 size="sm"
                 variant="subtle"
                 color="gray"
               >
                 <Plus color="#1b6f8d" size={16} />
               </ActionIcon>
               {/* )} */}
             </div>
           ) : (
             <span className="mr-2">{"--"}</span>
           )}
           <ActionIcon
             size="sm"
             variant="subtle"
             color="#2089ae"
             onClick={() => onViewClick(row.id)}
           >
             <Eye size={16} />
           </ActionIcon>
           {!row.agreementData?.json?.isLegacy ? (
             <ActionIcon
               size="sm"
               variant="subtle"
              //  color="gray"
               onClick={() => handleSearchClick(row.id)}
             >
               <History size={16} color="#1b6f8d"/>
             </ActionIcon>
           ) : (
             <Badge size="xs" variant="outline" color="gray">
               NA
             </Badge>
           )}
         </div>
       ),
     },
   ];
  return (
    <>
      <div className="flex flex-col">
        <div className="flex justify-between my-4">
          <Text>Repository</Text>
        </div>
      </div>

      {showModalRelated && (
        <Modal
          overflow="inside"
          opened
          onClose={handleCloseRelatedAgreementModal} // Call the handler on modal close
          size="calc(80vw)"
        >
          <RelatedAgreementModal agreementId={relatedAgreementId} />
        </Modal>
      )}
      <div className="flex w-full justify-between items-center">
        <div className="flex flex-col">
          <div className="flex flex-row-sm">
            {/* <Text size="xs" className="mb-2" color="gray">
              Case sensitive search
            </Text> */}
            <div className="flex items-center">
              {/* <TextInput
                value={listing.searchString}
                onChange={(input) => {
                  const val = getValueForInput(input);
                  setListing((prevState) => ({
                    ...prevState,
                    searchString: val,
                  }));
                }}
                placeholder="Type to search..."
                icon={<Search size={14} />}
              /> */}
              <Select
                className="mx-2"
                placeholder="select contract status"
                value={listing.statusType}
                onChange={(val) => {
                  setListing((prevState) => ({
                    ...prevState,
                    statusType: val,
                  }));
                }}
                data={statusOptions}
                style={{ minWidth: "228px" }}
              />
              <Select
                className="mx-2"
                placeholder="estamp"
                value={listing.estamp}
                onChange={(val) => {
                  setListing((prevState) => ({
                    ...prevState,
                    estamp: val,
                  }));
                }}
                data={estampOption}
                style={{ minWidth: "228px" }}
              />
              <Select
                className="mx-2"
                placeholder="select contract type"
                value={listing.agreementType}
                onChange={(val) => {
                  setListing((prevState) => ({
                    ...prevState,
                    agreementType: val,
                  }));
                }}
                data={agreementTypeOptions}
                style={{ minWidth: "228px" }}
              />
              <Select
                className="mx-2"
                placeholder="select obligation status"
                value={listing.obligationStatus}
                data={[
                  { label: "pending", value: "NA" },
                  { label: "created", value: "created" },
                  { label: "not required", value: "not required" },
                ]}
                onChange={(value) => {
                  setListing((prevState) => ({
                    ...prevState,
                    obligationStatus: value,
                  }));
                }}
                style={{ minWidth: "228px" }}
              />
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="flex w-full justify-between items-center">
        <div className="flex flex-col">
          <div className="flex flex-row">
            <div className="flex items-center">
              {/* <Select
                className="mx-2"
                placeholder="Select location"
                searchable={true}
                value={listing.location}
                onChange={(val) => {
                  setListing((prevState) => ({
                    ...prevState,
                    location: val,
                  }));
                }}
                data={INDIA_STATES_UNIONS}
                style={{ minWidth: "228px" }}
              /> */}
              <TextInput
                className="mx-2"
                placeholder="type job order"
                value={listing.jobOrder}
                onChange={(e) =>
                  setListing((preState) => ({
                    ...preState,
                    jobOrder: e.target.value,
                  }))
                }
                maw={400}
                mx="auto"
                style={{ minWidth: "228px" }}
              />
              <DatePicker
                className="mx-2"
                value={listing.startDate}
                onChange={(val) =>
                  setListing((preState) => ({ ...preState, startDate: val }))
                }
                placeholder="created date (from)"
                minDate={
                  new Date(new Date().setMonth(new Date().getMonth() - 3))
                }
                maw={400}
                mx="auto"
                style={{ minWidth: "228px" }}
              />
              <DatePicker
                className="mx-2"
                value={listing.endDate}
                onChange={(val) =>
                  setListing((preState) => ({ ...preState, endDate: val }))
                }
                placeholder="created date (to)"
                minDate={listing.startDate}
                disabled={listing.startDate ? false : true}
                style={{ minWidth: "228px" }}
              />
              <Select
                className="mx-2"
                value={listing.partyName}
                onChange={(value) => {
                  // const val = getValueForInput(input);
                  setListing((prevState) => ({
                    ...prevState,
                    partyName: value,
                  }));
                }}
                searchable
                placeholder="second party name"
                type="text"
                data={parties}
                style={{ minWidth: "228px" }}
              />

              <br />
            </div>
          </div>
        </div>
      </div>
      <br />
      <Button
        className="mx-2"
        variant="outline"
        onClick={() => fetchAgreementsList({ page: 1 })}
      >
        Search
      </Button>
      <Button className="mx-2"  onClick={clearHandler}>
        Clear
      </Button>
      <div className="flex float-right">
        <div className="flex">
          <Select
            value={listing.sortBy}
            onChange={(val) => handleKeyChange(val)}
            data={[
              { label: "created at", value: "createdAt" },
              { label: "end date", value: "dueDateOfContract" },
              { label: "type of agreement", value: "typeOfAgreement" },
              { label: "agreement value", value: "agreementValue" },
              { label: "ain", value: "id" },
            ]}
          />
          <ActionIcon className="mx-2" onClick={toggleOrder}>
            {listing.sortDirection === "asc" ? (
              <SortAscending size={32} />
            ) : (
              <SortDescending size={32} />
            )}
          </ActionIcon>
        </div>
        <Button
          className="mx-2 btn btn-success btn-lg "
          disabled={exportButtonLoading}
          onClick={handleCsvDownload}
          style={{
            backgroundColor: "#1b6f8d",
          }}
        >
          Export
        </Button>
      </div>
      <Modal
        overflow="inside"
        closeOnClickOutside={false}
        size="calc(30vw)"
        opened={open}
        onClose={() => setOpen(!open)}
        title="Delete Agreement"
      ></Modal>
      {showModal && (
        <Modal
          overflow="inside"
          opened
          onClose={handleCloseModal} // Call the handler on modal close
          size="calc(80vw)"
        >
          <AgreementAuditLogModal agreementId={agreementId} />
        </Modal>
      )}

      {currentUser.loginAs.id === 1 && (
        <Button
          disabled={deleteLoading || selectedIds.length === 0}
          className="ml-2"
          style={{
            backgroundColor: deleteLoading ? "#ffcccc" : "#ff4d4d",
            // borderRadius: "0.5rem",
            color: "#F5F5F5",
            // width: '180px',
          }}
          onClick={deleteHandler}
        >
          {deleteLoading ? (
            <BeatLoader size={10} color={colors.rejected} />
          ) : (
            "Delete"
          )}
        </Button>
      )}
      <br />
      {/* </div> */}
      {/* </div> */}
      {/* </div> */}
      {uiConfigs.loading === loadingStates.LOADING && (
        <div className="flex flex-col">
          {Array.from({ length: 10 }).map((i) => (
            <Skeleton key={i} height={30} radius="md" className="my-1 w-full" />
          ))}
          <div className="flex flex-row justify-center">
            <Skeleton height={40} radius="md" className="w-40" />
          </div>
        </div>
      )}

       <div className="flex flex-col gap-4 mt-2">
        {uiConfigs.loading === loadingStates.LOADING ? (
          <div className="flex flex-col gap-2">
            {Array.from({ length: 8 }).map((_, i) => (
              <Skeleton key={i} height={50} radius="md" />
            ))}
          </div>
        ) : listing.loaded && data?.length > 0 ? (
          <>
            {/* Table Section */}

            <UniversalTable
              headers={tableHeaders}
              // Map your existing data variable
              data={
                data?.filter((v) => v.agreementData?.json?.typeOfAgreement) ||
                []
              }
              // Convert your enum-based loading to a boolean for the component
              loading={uiConfigs.loading === loadingStates.LOADING}
              emptyMessage="No contracts found"
            />

            <TablePagination
              totalCount={listing.agreementsCount}
              page={uiConfigs.page}
              pageSize={pageSize}
              onPageChange={(page) => setUiConfigs({ ...uiConfigs, page })}
              onPageSizeChange={(val) => setPageSize(val)}
              dataLength={data.length}
            />
          </>
        ) : (
          <div className="flex flex-col items-center justify-center py-24 bg-slate-50 rounded-xl border-2 border-dashed border-slate-200 mt-6">
            <Search size={48} color="#94a3b8" strokeWidth={1.5} />
            <Text color="dimmed" mt="md" weight={500}>
              No agreements found matching your search.
            </Text>
            <Button
              variant="subtle"
              size="xs"
              mt="sm"
              onClick={clearHandler}
              color="#1b6f8d"
            >
              Clear All Filters
            </Button>
          </div>
        )}
      </div>
      <Modal
        opened={open}
        onClose={() => setOpen(false)}
        size="calc(30vw)"
        style={{ marginTop: "12%" }}
        title="select contract Type"
      >
        <div className={Styles["popup-desig"]}>
          <p
            style={{
              cursor: "pointer",
              border: "2px solid lightblue",
              padding: "8px",
              margin: "0",
              marginBottom: "8px",
            }}
            onClick={() => navigate("/app/agreements_manager/agreements/new")}
          >
            Individual Agreement
          </p>
          <p
            style={{
              cursor: "pointer",
              border: "2px solid lightblue",
              padding: "8px",
              margin: "0",
            }}
            onClick={() =>
              navigate("/app/agreements_manager/agreements/new-bulk")
            }
          >
            Bulk Agreement
          </p>
          <div style={{ textAlign: "center", paddingTop: "3%" }}>
            <button
              style={{
                cursor: "pointer",
                background: "red",
                border: "none",
                padding: "8px",
                color: "white",
                margin: "5px 0",
                borderRadius: "10%",
              }}
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default DocsLocker;
